import { render, staticRenderFns } from "./ElementenView.vue?vue&type=template&id=8a843e5a"
import script from "./ElementenView.vue?vue&type=script&lang=js"
export * from "./ElementenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports